import Error404Page from 'app/main/errors/Error404Page';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { cloneDeep } from 'lodash-es';
import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router';

import { getAgencyInvitationRoutes } from './agencyInvitationRoutes';

const StaffRoster = lazy(() => import('../../../../main/agency/profile/users-sections/staff-roster/StaffRoster'));

const AddMember = lazy(
  () => import('../../../../main/agency/profile/users-sections/staff-roster/sections/add-member/AddMember'),
);

const AgencyUsersSections = lazy(() => import('../../../../main/agency/profile/users-sections/AgencyUsersSections'));

export const agencyUsersRoutes: RouteObject[] = [
  {
    path: '',
    element: <AgencyUsersSections />,
    children: [
      {
        path: '',
        element: (
          <Suspense fallback={<DataLoader />}>
            <StaffRoster />
          </Suspense>
        ),
      },
      {
        path: 'add-member',
        element: (
          <Suspense fallback={<DataLoader />}>
            <AddMember />
          </Suspense>
        ),
      },
      {
        path: ':invitationId',
        children: getAgencyInvitationRoutes([]),
      },
      {
        path: '*',
        element: <Error404Page />,
      },
      {
        path: ':any/*',
        element: <Error404Page />,
      },
    ],
  },
];

export const getAgencyUsersRoutes = (excludes: string[]): RouteObject[] => {
  const routes = cloneDeep(agencyUsersRoutes);
  const result =
    routes[0].children?.filter((route: RouteObject) => {
      const path = route.path || '';
      return !excludes.some((exclude) => path.includes(exclude));
    }) ?? [];

  routes[0].children = result;
  return routes;
};
